import { RESET_USER } from '.';

export const types = {
  SHOW_ERROR: 'ERROR/SHOW_ERROR',
  STORE_ERROR: 'ERROR/STORE_ERROR',
  RESET_ERROR_STRUCTURE: 'ERROR/RESET_ERROR_STRUCTURE',
}

const initialState = {
  handlingCode: 0,
  login: {
    visible: false,
    targetUrl: '',
  },
  placeWhereError: '',
};

const ErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER: return initialState;
    case types.SHOW_ERROR: {
      return { ...state }
    }
    case types.STORE_ERROR: {
      const { handlingCode, currentPath } = action.payload;
      // SOLO SE ACTUALIZA EL ERROR SI ES MÁS IMPORTANTE QUE EL QUE TENEMOS DE ANTES
      const lastHandlingCode = state.handlingCode;
      if (lastHandlingCode >= 0 && handlingCode < 0 && (handlingCode < lastHandlingCode)) {
        const newError = handlingCode;
        return {
          ...state,
          handlingCode: newError,
          placeWhereError: (currentPath !== '/error') ? currentPath : state.placeWhereError,
        }
      }
      return {
        ...state,
        placeWhereError: (currentPath !== '/error') ? currentPath : state.placeWhereError,
      }
    }
    case types.RESET_ERROR_STRUCTURE: {
      return {
        ...state,
        handlingCode: 0,
        placeWhereError: '',
      }
    }
    default:
      return state;
  }
}

export const actions = {
  showError: args => ({ type: types.SHOW_ERROR, payload: args }),
  storeError: args => ({ type: types.STORE_ERROR, payload: args }),
  clearError: () => ({ type: types.RESET_ERROR_STRUCTURE }),
}

export default ErrorReducer;
